export enum ClickWrapStatus {
  NOT_STARTED = 'NOT_STARTED',
  AGREED = 'AGREED',
  DECLINED = 'DECLINED',
  INVALID = 'INVALID',
}

export interface ClickWrap {
  createdBy: string
  dateCreated: string
  dateExpired: string
  dateTermsAccepted: string
  docusignDocumentName: string
  docusignDocumentVersion: string
  docusignId: string
  status: ClickWrapStatus
  team: string
}

export function parseClickWrap(data: any): ClickWrap {
  return {
    createdBy: data.created_by,
    dateCreated: data.date_created,
    dateExpired: data.date_expired,
    dateTermsAccepted: data.date_terms_accepted,
    docusignDocumentName: data.docusign_document_name,
    docusignDocumentVersion: data.docusign_document_version,
    docusignId: data.docusign_id,
    status: data.status,
    team: data.team,
  }
}
